import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import ActiveChip from 'components/Common/ActiveChip';

// eslint-disable-next-line import/prefer-default-export
export const CustomerLinkCellRenderer = ({
  data: form,
  context
}) => {
  const { permissions, showStatusChip } = context;
  const link = `/customer/${ form.customerDbId }`;
  const defaultDisplayData = `${ form.customerId + ((form.customerName && form.customerName.length > 0) ? `-${ form.customerName }` : '') }`;
  return (
    <div className="form-action-btn-group">
      { form.customerDbId > 0 && AccessControl.hasPermission(permissions, [ActivityPerms.customerEdit, ActivityPerms.customerPageView]) && <span className="text-ellipsis">
        <Link to={ link } className="text-bold" title={ defaultDisplayData }>{ defaultDisplayData }</Link>
      </span> }
      { form.customerDbId > 0 && !AccessControl.hasPermission(permissions, [ActivityPerms.customerEdit, ActivityPerms.customerPageView]) && <span className="text-ellipsis">
        <span className="text-bold" title={ defaultDisplayData }>{ defaultDisplayData }</span>
      </span> }
      { form.customerDbId <= 0 && 'N/A' }
      { showStatusChip && <div> <ActiveChip isActive={ form.customerIsActive } /> </div>}
    </div>
  );
};

CustomerLinkCellRenderer.propTypes = {
  data: PropTypes.shape(),
  context: PropTypes.shape({
    permissions: PropTypes.arrayOf(PropTypes.string),
    showStatusChip: PropTypes.bool
  })
};

CustomerLinkCellRenderer.defaultProps = {
  context: {
    showStatusChip: false
  },
  data: {}
};
